import { styled, Typography } from 'opensolar-ui'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { formatDateString } from 'util/misc'

const AuditRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
}))

const DashboardTile = styled('div')(({ theme }) => ({
  flex: '1 1 300px',
  minWidth: 200,
  maxWidth: 320,
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[1],
}))

const AuditMetricLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  paddingBottom: theme.spacing(1),
}))

const AuditMetricDate = styled(Typography)(({ theme }) => ({ paddingBottom: theme.spacing(0.5) }))

const AuditMetricEmail = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

type AuditMetricTileProps = {
  title: string
  date?: string | Date | null
  email?: string | null
}

const AuditMetricTile: FC<AuditMetricTileProps> = ({ title, date, email }) => (
  <DashboardTile>
    <AuditMetricLabel textVariant="caption1Bold">{title}</AuditMetricLabel>
    {date ? <AuditMetricDate textVariant="body1SemiBold">{formatDateString(date)}</AuditMetricDate> : null}
    {email ? <AuditMetricEmail textVariant="helper1">{email}</AuditMetricEmail> : null}
  </DashboardTile>
)

export type NetworkTariffStaffAuditProps = {
  createdDate?: string | Date | null
  createdByEmail?: string | null
  modifiedDate?: string | Date | null
  modifiedByEmail?: string | null
}

export const NetworkTariffStaffAudit: FC<NetworkTariffStaffAuditProps> = ({
  createdDate,
  createdByEmail,
  modifiedDate,
  modifiedByEmail,
}) => {
  const doNotTranslate = useTranslate()
  const showCreated = Boolean(createdDate || createdByEmail)
  const showModified = Boolean(modifiedDate || modifiedByEmail)
  if (!showCreated && !showModified) {
    return null
  }
  return (
    <AuditRoot>
      {showCreated ? (
        <AuditMetricTile title={doNotTranslate('Created')} date={createdDate} email={createdByEmail} />
      ) : null}
      {showModified ? (
        <AuditMetricTile title={doNotTranslate('Last updated')} date={modifiedDate} email={modifiedByEmail} />
      ) : null}
    </AuditRoot>
  )
}
